module.exports = __webpack_public_path__ + "static/img-a5fe7cd46b205c0b95e80087dd57c2fb.jpeg";